import { render, staticRenderFns } from "./CanvasMessage.vue?vue&type=template&id=7499fa90&scoped=true&lang=html&"
import script from "./CanvasMessage.vue?vue&type=script&lang=js&"
export * from "./CanvasMessage.vue?vue&type=script&lang=js&"
import style0 from "./CanvasMessage.vue?vue&type=style&index=0&id=7499fa90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7499fa90",
  null
  
)

export default component.exports